import { SUPPORTED_COUNTRIES } from '../types/address';
import { ALL_LANGUAGES, DEFAULT_CURRENCY, DEFAULT_REGION, } from '../types/internationalization';
// Defined at top level to avoid re-creating the regex on every request
// Test regex here: https://regex101.com/r/LFNEnk/1
const validLocaleRegex = /[a-z]{2}-[a-zA-Z]{2}(?=\/|$)/;
const supportedLocales = [
    'de-EU',
    'en-AE',
    'en-AU',
    'en-BH',
    'en-CA',
    'en-EU',
    'en-HK',
    'en-IL',
    'en-JP',
    'en-KR',
    'en-KW',
    'en-NZ',
    'en-SA',
    'en-SG',
    'en-TW',
    'en-UK',
    'en-US',
    'en-ZA',
    'fr-CA',
    'fr-EU',
];
export const isValidLanguage = (lang) => {
    const allLangs = [...ALL_LANGUAGES];
    return lang !== undefined && allLangs.includes(lang);
};
export const isValidLocale = (locale) => locale !== undefined &&
    supportedLocales.some((supportedLocale) => supportedLocale.toLowerCase() === locale.toLowerCase());
export const getLocaleFromSlug = (slug) => {
    const regexResult = validLocaleRegex.exec(slug);
    if (regexResult && isValidLocale(regexResult[0])) {
        const [language, region] = regexResult[0].split('-');
        return `${language}-${region.toUpperCase()}`;
    }
};
export const sanitizePathname = (pathname) => {
    const toRemove = getLocaleFromSlug(pathname);
    const withSlashesRemoved = pathname.replace(/^\/+/, '');
    return withSlashesRemoved.replace(`${toRemove}`, '');
};
/* eslint-disable id-length */
export const getCurrencyFromLocale = (locale) => {
    const currencyMap = {
        AE: 'aed',
        AU: 'aud',
        CA: 'cad',
        EU: 'eur',
        NZ: 'nzd',
        SA: 'sar',
        UK: 'gbp',
        US: 'usd',
    };
    return currencyMap[locale.region] ?? DEFAULT_CURRENCY;
};
export const getRegionFromCheckoutRegion = (checkoutOrigin) => {
    const checkoutRegionToRegionMap = {
        australia: 'AU',
        ca: 'CA',
        domestic: 'US',
        international: 'EU',
        nz: 'NZ',
        sa: 'SA',
        uae: 'AE',
        uk: 'UK',
    };
    return checkoutRegionToRegionMap[checkoutOrigin];
};
export const getCurrencyForBillingRegion = (billingRegion) => {
    const currencyMap = {
        australia: 'aud',
        ca: 'cad',
        domestic: 'usd',
        international: 'eur',
        nz: 'nzd',
        sa: 'sar',
        uae: 'aed',
        uk: 'gbp',
    };
    return currencyMap[billingRegion];
};
/* eslint-enable id-length */
/**
 * Takes in any country code and returns the region the country is grouped under
 * @param countryCode alpha2 country code
 * @returns string representing the region the country is grouped under, defaults to US if country is not part of an existing group
 */
export const getRegionFromRequest = (countryCode) => {
    return (SUPPORTED_COUNTRIES.find((country) => country.alpha2 === countryCode)
        ?.region ?? DEFAULT_REGION);
};
export const isAllowedRegion = (region) => {
    const allowedRegions = ['AE', 'AU', 'CA', 'EU', 'NZ', 'UK', 'US'];
    return (!region ||
        allowedRegions.some((allowedRegion) => region.toLowerCase().includes(allowedRegion.toLowerCase())));
};
